import React from 'react';
import { Row, Col, Skeleton } from 'antd';
import { withTranslation } from 'react-i18next';
import { SectionTitle } from '../../styles/checkoutStyles';
import HighlightCard from './HighlightCard';

const PerformanceHighlights = ({ loading, data, t }) => {
  return (
    <div>
      <SectionTitle level={4}>{t('Campaign performance')}</SectionTitle>
      {loading ? (
        <Row gutter={[16, 16]}>
          <Col xs={24} md={8}>
            <Skeleton active style={{ width: '100%', height: '100px' }} />
          </Col>
          <Col xs={24} md={8}>
            <Skeleton active style={{ width: '100%', height: '100px' }} />
          </Col>
          <Col xs={24} md={8}>
            <Skeleton active style={{ width: '100%', height: '100px' }} />
          </Col>
        </Row>
      ) : (
        <Row gutter={[16, 16]} type="flex">
          <Col xs={12} sm={12} md={6}>
            <HighlightCard
              value={data.day}
              label={t('Day of greatest reach')}
              tooltip={t('Day of the week with the highest projected reach.')}
            />
          </Col>
          <Col xs={12} sm={12} md={6}>
            <HighlightCard
              value={data.reach}
              label={t('Highest reach day')}
              tooltip={t('Total number of impressions on the best day.')}
            />
          </Col>
          <Col xs={12} sm={12} md={6}>
            <HighlightCard
              value={data.hour}
              label={t('Time of greatest reach')}
              tooltip={t('Time slot with the highest projected reach.')}
            />
          </Col>
          <Col xs={12} sm={12} md={6}>
            <HighlightCard
              value={data.hourlyReach}
              label={t('Highest hourly reach')}
              tooltip={t('Number of impressions in the best time slot.')}
            />
          </Col>
        </Row>
      )}
    </div>
  );
};

export default withTranslation()(PerformanceHighlights);
